// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__CY1Wc","footer":"ModalError_footer__8zRPd"};